import $ from 'jquery'
import React from 'react'
import { Component } from 'react'


class Popup extends Component {

    componentDidMount() {
        window.addEventListener("keydown", this.onKeyDown);
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.onKeyDown);
    }

    onKeyDown = (e) => {
        // console.log("KEY", e.key, e.keyCode);
        if (e.key === "Escape")
            if (this.props.onClose)
                this.props.onClose();
    };

    render() {
        const { children, onClose } = this.props;

        return (
            <div>
                <div
                    className={"popup-background"}
                    onClick={(e) => {
                        if (e.target === e.currentTarget) {
                            e.preventDefault();
                            if (onClose)
                                onClose();
                        }
                    }}
                >
                    <div className={"popup"}>
                        {children}
                    </div>
                </div>
            </div>
        );
    }
}


export default Popup


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/Popup.js